import { useEffect, useState } from 'react'
import { api } from '@lib/orpc-client'

type KYCDetail = Awaited<ReturnType<typeof api.walletV2.kyc.myDetail>>

const useKYCDetail = () => {
    const [data, setData] = useState<KYCDetail | undefined>(undefined)
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<unknown>(undefined)

    useEffect(() => {
        let cancelled = false
        setIsLoading(true)
        setError(undefined)
        api.walletV2.kyc.myDetail({})
            .then((result: KYCDetail) => {
                if (cancelled) return
                setData(result)
            })
            .catch((err: unknown) => {
                if (cancelled) return
                setError(err)
            })
            .finally(() => {
                if (cancelled) return
                setIsLoading(false)
            })
        return () => {
            cancelled = true
        }
    }, [])

    const levelNumber: number = Number(data?.kyc_level.match(/\d+/)?.[0]) || 0

    return {
        data,
        isLoading,
        error,
        levelNumber
    }
}

export default useKYCDetail
